module.exports = __webpack_public_path__ + "img/1440.bd6b50ab.jpg";